import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { DuoClairLogo } from "@/components/DuoClairLogo";
import { SiteMenu } from "@/components/SiteMenu";

const Section = ({ title, children }) => (
  <section className="space-y-2.5">
    <h2 className="font-sans font-bold text-base sm:text-lg text-slate-100">{title}</h2>
    <div className="text-sm sm:text-[15px] text-zinc-400 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function PrivacyPage() {
  return (
    <div className="min-h-screen" data-testid="privacy-page">
      <header className="sticky top-0 z-40 border-b border-white/5 bg-black/50 backdrop-blur-xl">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <DuoClairLogo compact />
          <div className="flex items-center gap-3">
            <Link to="/" className="hidden sm:inline-flex items-center gap-2 text-xs text-zinc-500 hover:text-gold transition-colors" data-testid="privacy-back-link">
              <ArrowLeft className="w-3.5 h-3.5" /> Torna al sito
            </Link>
            <SiteMenu />
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-10 sm:py-14 space-y-9">
        <div>
          <h1 className="font-display uppercase tracking-wide text-3xl sm:text-4xl text-slate-100 mb-5" data-testid="privacy-title">
            Informativa <span className="gold-text">Privacy</span>
          </h1>
          <p className="text-sm sm:text-[15px] text-zinc-400 leading-relaxed">
            I dati inseriti tramite questo sito vengono utilizzati esclusivamente per rispondere alle
            richieste di informazioni, analizzare le esigenze dell'attività e ricontattare l'utente in
            relazione ai servizi DuoClair.
          </p>
        </div>

        <div className="gold-hairline" />

        <Section title="Titolare del trattamento">
          <p>
            DuoClair — Contatto:{" "}
            <a href="mailto:clairduo@gmail.com" className="text-gold-light hover:underline" data-testid="privacy-contact-email">
              clairduo@gmail.com
            </a>
          </p>
        </Section>

        <Section title="Dati trattati">
          <p>
            Possiamo raccogliere i dati che l'utente decide di fornirci tramite il modulo, come nome,
            attività, numero di telefono, email, profilo social, sito web e informazioni relative alla richiesta.
          </p>
        </Section>

        <Section title="Finalità">
          <p>
            I dati vengono utilizzati esclusivamente per gestire la richiesta, ricontattare l'utente e
            predisporre eventuali informazioni o proposte relative ai servizi DuoClair.
          </p>
        </Section>

        <Section title="Conservazione">
          <p>
            I dati vengono conservati solo per il tempo necessario alla gestione della richiesta e degli
            eventuali rapporti successivi.
          </p>
        </Section>

        <Section title="Condivisione dei dati">
          <p>
            I dati non vengono venduti né utilizzati per finalità diverse da quelle indicate. Possono essere
            trattati tramite i servizi tecnici necessari al funzionamento del sito e delle comunicazioni.
          </p>
        </Section>

        <Section title="Diritti">
          <p>
            È possibile chiedere accesso, rettifica o cancellazione dei propri dati scrivendo a{" "}
            <a href="mailto:clairduo@gmail.com" className="text-gold-light hover:underline">
              clairduo@gmail.com
            </a>
            . È inoltre possibile rivolgersi all'autorità di controllo competente in materia di protezione
            dei dati personali.
          </p>
        </Section>

        <div className="gold-hairline" />
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">
          Ultimo aggiornamento: ottobre 2026
        </p>
      </main>
    </div>
  );
}
